<template>
	<Card>
		<div class="container">
			<div class="row pl-3 pr-3 pb-5">
				<div class="col-xl-3 admin-link">
					<a class="nav-link" href="/admin/account"><p>Manage Account</p></a>
				</div>
				<div class="col-xl-3 admin-link"  v-if="user && user.isAdmin">
					<a class="nav-link" href="/admin/channeltypes">
						<p>Channel Types</p>
					</a>
				</div>
				<div class="col-xl-3 admin-link">
					<a class="nav-link" href="/admin/rates">
						<p>Rates</p>
					</a>
				</div>
				<div class="col-xl-3 admin-link">
					<a class="nav-link" href="/admin/manage-linked-sites">
						<p>Manage Linked Sites</p>
					</a>
				</div>
			</div>
			<div class="row create-group" v-if="!!isEdit">
				<div class="col-xl-4 col-sm-6">
					<label for="sname" class="t-title">Name:&nbsp;</label>
					<input id="sname" type="text" v-model="editItem.name" class="site-input" />
				</div>
				<div class="col-xl-4 col-sm-6">
					<label for="sname" class="t-title">Type:&nbsp;</label>
					<select v-model="editItem.site_type_id" id="site_type" class="site-select">
						<option v-for="_type in siteTypes" :value="_type.value">
						{{ _type.label }}
						</option>
					</select>
				</div>
				<div class="col-xl-4 col-sm-6">
					<button class="submit-button" @click="cancelEdit()">Cancel</button>
					<button class="submit-button" @click="editSite()">Submit</button>
				</div>
			</div>
			<div class="row create-group" v-if="!!addSite">
				<div class="col-xl-4">
					<label for="address" class="t-title">Mac Address:&nbsp;</label>
					<input
						id="address"
						type="text"
						v-model="address"
						class="site-input"
					/>
				</div>
				<div class="col-xl-3">
					<label for="name" class="t-title">Name:&nbsp;</label>
					<input id="name" v-model="sitename" type="text" class="site-input" />
				</div>
				<div class="col-xl-3">
					<label for="devices" class="t-title">Devices:&nbsp;</label>
					<select v-model="site_type_id" id="site_type" class="site-select">
						<option v-for="_type in siteTypes" :value="_type.value">
						{{ _type.label }}
						</option>
					</select>
					<button type="button" class="add_button" @click="createSite()">
						Go
					</button>
				</div>
			</div>
			<div class="row justify-content-center create-group" v-if="!!importSite">
				<label
					>File
					<input
						class="input-file"
						name="file"
						type="file"
						@change="handleFileUpload($event)"
					/>
				</label>
				<br />
				<button class="submit-button" @click="submitFile()">Submit</button>
			</div>
			<div class="row">
				<div class="col-xl-12" style="position: relative">
					<button class="add-button" @click="showCreate()" v-if="!addSite && user && user.isAdmin">
						<i class="fa fa-plus"></i>
						Add New Site
					</button>
					<button
						class="import-button"
						@click="showImport()"
						v-if="!importSite  && user && user.isAdmin"
					>
						<i class="fa fa-excel"></i>
						Import from CSV
					</button>
					<v-client-table
						:columns="fields"
						:data="data"
						:options="options"
						class="text-center"
					>
						<template v-slot:actions="props">
							<button class="filter-action1" @click="editSiteName(props.row)">
								<i class="fa fa-edit"></i> Edit Name / Type
							</button>
							&nbsp;&nbsp;
							<button class="filter-action1" @click="editSiteCircuitGroup(props.row)">
								<i class="fa fa-edit"></i> Edit Circuit Group
							</button>
							&nbsp;&nbsp;
							<button class="filter-action1" @click="editChannel(props.row)">
								<i class="fa fa-edit"></i> Edit Channeltype / Gateway</button
							>&nbsp;&nbsp;
							<button class="filter-action1" @click="deleteSite(props.row)"  v-if="user && user.isAdmin">
								<i class="fa fa-remove"></i> Delete Site
							</button>
						</template>
					</v-client-table>
				</div>
			</div>
		</div>
	</Card>
</template>

<script>
import Card from "@/components/Cards/Card.vue";
import axios from "axios";
import Vue from "vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
import { mapActions, mapState, mapGetters } from "vuex";
Vue.use(ClientTable);

export default {
	name: "Admin",
	components: {
		Card,
	},
	data() {
		return {
			number: null,
			name: "",
			file: "",
			addSite: false,
			importSite: false,
			fields: ["id", "name", "actions"],
			data: [],
			siteTypes: [],
			sitename: "",
			site_type_id: null,
			editItem: {
				name: '',
				site_type_id: null
			},
			address: "",
			isEdit: false,
			editId: null,
			options: {
				headings: {
					id: "id",
					name: "name",
				},
				sortable: ["id", "name"],
				texts: {
					filterPlaceholder: "Search...",
				},
				perPage: 10,
				editableColumns: ["name"],
			},
		};
	},
	computed: {
		...mapState('admin', ['apiURL']),
		...mapGetters({
			user: 'auth/getUser'
		})
	},
	async created() {
		const siteData = await this.getSites(this.user.id);
		const _types = await this.getSiteTypes();
		this.processSiteData(siteData);
		this.processSiteTypesData(_types);
	},
	methods: {
		...mapActions({
			getSites: "admin/getSites",
			getSiteTypes: "admin/getSiteTypes"
		}),
		handleFileUpload(event) {
			this.file = event.target.files[0];
		},
		submitFile(event) {
			this.importSite = !this.importSite;
			let formData = new FormData();
			formData.append("file", this.file);
			let vm = this;
			axios
				.post(vm.apiURL + "/admin/importSites.php", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function () {
					vm.$toasted.show("File is imported successfully", {
						type: "success",
						duration: 2500,
					});
				})
				.catch(function () {
					console.log("FAILURE!!");
				});
		},
		cancelEdit() {
			this.isEdit = false;
		},
		async editSite() {
			let vm = this;
			let changeItem = this.data.find((i) => i.id === this.editId);
			changeItem.name = this.editItem.name;
			
			axios
				.post(vm.apiURL + "/admin/edit.php", {
					name: this.editItem.name,
					id: this.editItem.id,
					type: this.editItem.site_type_id
				})
				.then((res) => {
					console.log(res.data);
					vm.editId = null;
					vm._sname = "";
					vm.isEdit = false;
					vm.$toasted.show("Site is edited successfully", {
						type: "success",
						duration: 2500,
					});
				})
				.catch((error) => {
					console.log("Failure", error);
				});
		},
		editSiteName(row) {
			this.editItem = row;
			this.isEdit = true;
			this.editId = row.id;
		},
		editChannel(row) {
			this.$router.push({ path: "admin/site/" + row.id + "/edit", query: {name: "ttest"}});
		},
		editSiteCircuitGroup(row) {
			console.log(row);
			this.$router.push({name: 'edit_group', params:{id: row.id, name: row.name}});
		},
		deleteSite(row) {
			let _index = 0;
			this.data.forEach((item, index) => {
				if (item.name === row.name) _index = index;
			});
			this.data.splice(_index, 1);
			let vm = this;
			axios
				.post(vm.apiURL + "/admin/delete.php", { id: row.id })
				.then(() => {
					console.log("success");
					vm.$toasted.show("Site is deleteed successfully", {
						type: "success",
						duration: 2500,
					});
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showCreate() {
			this.addSite = true;
		},
		createSite() {
			this.addSite = !this.addSite;
			let data = {
				name: this.sitename,
				mac_address: this.address,
				type: this.site_type_id,
				user: this.user.id
			};
			let vm = this;
			this.sitename = "";
			this.address = "";
			axios
				.post(vm.apiURL + "/admin/create.php", data)
				.then(function () {
					vm.$toasted.show("New site is created successfully", {
						type: "success",
						duration: 2500,
					});
				})
				.catch((error) => {
					console.log("FAILURE!!", error);
				});
		},
		showImport() {
			this.importSite = true;
		},
		processSiteTypesData(data) {
			data.forEach((el, index) => {
				let item = {
					label: el.site_type_name,
					value: index + 1
				}

				this.siteTypes.push(item);
			});
		},
		processSiteData(data) {
			for (let i = 0; i < data.length; i++) {
				let item = {
					id: data[i]["id"],
					name: data[i]["sitename"],
					type: data[i]["site_type_id"]
				};

				if (this.user.isAdmin) {
					this.data.push(item);
				} else {
					if (data[i]['sitename'] == this.user.site) {
						this.data.push(item);
					}
				}
			}
		},
		loadTextFromFile() {
			let validIds = [];
			let newTableData = [];

			for (let i = 14; i < 67; i++) {
				if (i % 2 === 0) {
					validIds.push(i);
				}
			}
			for (let i = 0; i < tableData.length; i++) {
				let itemArray = [];
				for (let j = 0; j < tableData[i].length; j++) {
					if (validIds.includes(j)) {
						itemArray.push(tableData[i][j]);
					}
				}
				itemArray.splice(-1);
				newTableData.push(itemArray);
			}

			let dayData = [];
			let nightData = [];

			for (let i = 0; i < newTableData[0].length; i++) {
				let total = 0;
				for (let j = 1; j < 415; j++) {
					total += parseFloat(newTableData[j][i]);
				}
				let key = newTableData[0][i];
				let item = { key: key, value: parseFloat(total.toFixed(2)) };
				nightData.push(item);

				total = 0;
				for (let k = 415; k < newTableData.length; k++) {
					total += parseFloat(newTableData[k][i]);
				}

				key = newTableData[0][i];
				item = { key: key, value: parseFloat(total.toFixed(2)) };
				dayData.push(item);
			}

			let _nightData = [];
			let kitchenTotal = 0;
			for (let i = 0; i < 2; i++) {
				kitchenTotal += nightData[i].value;
			}
			_nightData.push({ name: "kitchen", value: kitchenTotal });

			let mbportTotal = 0;
			for (let i = 2; i < 8; i++) {
				mbportTotal += nightData[i].value;
			}
			_nightData.push({ name: "mbport", value: mbportTotal });

			let electrakTotal = 0;
			for (let i = 8; i < 13; i++) {
				electrakTotal += nightData[i].value;
			}
			_nightData.push({ name: "electrak", value: electrakTotal });
			_nightData.push({ name: "ac", value: nightData[13].value });

			let overallTotal = 0;
			for (let i = 14; i < 17; i++) {
				overallTotal += nightData[i].value;
			}
			_nightData.push({ name: "overall", value: overallTotal });

			let lightTotal = 0;
			for (let i = 17; i < nightData.length; i++) {
				lightTotal += nightData[i].value;
			}
			_nightData.push({ name: "light", value: lightTotal });

			let _dayData = [];
			kitchenTotal = 0;
			for (let i = 0; i < 2; i++) {
				kitchenTotal += dayData[i].value;
			}
			_dayData.push({ name: "kitchen", value: kitchenTotal });

			mbportTotal = 0;
			for (let i = 2; i < 8; i++) {
				mbportTotal += dayData[i].value;
			}
			_dayData.push({ name: "mbport", value: mbportTotal });

			electrakTotal = 0;
			for (let i = 8; i < 13; i++) {
				electrakTotal += dayData[i].value;
			}
			_dayData.push({ name: "electrak", value: electrakTotal });
			_dayData.push({ name: "ac", value: dayData[13].value });

			overallTotal = 0;
			for (let i = 14; i < 17; i++) {
				overallTotal += dayData[i].value;
			}
			_dayData.push({ name: "overall", value: overallTotal });

			lightTotal = 0;
			for (let i = 17; i < dayData.length; i++) {
				lightTotal += dayData[i].value;
			}
			_dayData.push({ name: "light", value: lightTotal });
		},
	},
};
</script>

<style lang="scss">
.create-group {
	.t-title {
		color: white;
	}
}
.add-button {
	position: absolute;
	top: 30px;
	left: 48%;
	width: 180px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.import-button {
	position: absolute;
	top: 30px;
	left: 28%;
	width: 180px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}

.submit-button {
	width: 50%;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	padding-left: 15px;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}
.input-file {
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}
.filter-action1 {
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	font-size: 14px;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}

.add_button {
	width: 60px;
	height: 40px;
	border: 1px solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	font-family: "Nunito Sans Light";
	&:hover {
		background-color: #1f5881;
	}
}
.VueTables__search__input.form-control,
.site-input,
.site-select {
	height: 40px;
	background-color: #1e365d;
	color: white !important;
	opacity: 0.9;
	border: 1px solid #fdfdfd;
	border-radius: 4px;

	&:hover,
	&:active,
	&:focus {
		background-color: #1e365d;
	}
}

.VueTables__table.table.table-striped.table-bordered.table-hover {
	border: 1px solid #fdfdfd;
	text-align: center;
	font-size: 13px;
	thead {
		background-color: #1f5881;
		color: white;
		text-transform: capitalize;

		th {
			padding: 10px 4px;
		}
	}

	tbody {
		tr {
			background-color: #1e365d !important;
			color: white;
			height: 40px;

			td {
				padding: 10px;
				font-size: 14px;
			}
		}
	}
}

.VueTables__search-field {
	padding-top: 30px;
	label {
		display: none !important;
	}
}

.VueTables__limit {
	padding-top: 30px;
	label {
		display: none !important;
	}
}
.VueTables__limit-field select {
	background-color: #1e365d;
	color: white !important;
	opacity: 0.9;
	border: 1px solid #fdfdfd;
	border-radius: 4px;

	&:hover,
	&:active,
	&:focus {
		background-color: #1e365d;
	}
}

.VuePagination {
	justify-content: center;

	ul.VuePagination__pagination {
		.page-link {
			background: transparent;
			color: white;
			border: none;
		}

		.page-item.active {
			background: #1f5881;
		}
		.page-item.disabled .page-link {
			color: #6c757d;
		}
	}
	p {
		display: none;
	}
}

.admin-link {
	border: 1px solid #fefefe;
	text-align: center;
	align-items: center;
	&:hover {
		background: #1f5881;
	}
	p {
		margin-bottom: 0px;
		color: white;
		opacity: 0.8;
	}
}
</style>
